const path = window.location.href;

if (path.includes("netlify")) {
  module.exports = {
    PILLOW_CATEGORY: "",
    PILLOW_SUB_CATEGORY: "",
    API_ENDPOINT: "https://apis.polyfoundry.com/prod/apis/v2",

    GET_URL: (path) => {
      if (path) {
        return `https://app.poly9.ai/public/${path}`
      }
    },
    compnayId: "5f991484a0d40e0e988e1722",
  };
  // } else if (path.includes("netlify")) {
  //   module.exports = {
  //     PILLOW_CATEGORY: "",
  //     PILLOW_SUB_CATEGORY: "",
  //     API_ENDPOINT: "https://test.virtuosopastiche.com/test/apis/v2/",
  //     GET_URL: (path) => `https://${preFix}.pothigara.com/public/${path}`,
  //     compnayId: "5f991484a0d40e0e988e1722",
  //   };
} else {
  module.exports = {
    PILLOW_CATEGORY: "",
    PILLOW_SUB_CATEGORY: "",
    API_ENDPOINT: "https://apis.polyfoundry.com/prod/apis/v2",
    // API_ENDPOINT: "https://api.indicors.com/prod/apis/v2",
    // API_ENDPOINT: "https://test.virtuosopastiche.com/test/apis/v2/",
    // GET_URL: (path) => `https://www.pothigara.com/public/${path}`,
    GET_URL: (path) => {
      return `https://app.poly9.ai/public/${path}`
    },
    // compnayId:"5f991484a0d40e0e988e1722",
    compnayId: "5d9ecbd973fa720b9cce4308",
  };
}

// https://test.virtuosopastiche.com/test/apis/v2/
